import installComponentLayouts from './layouts'
import installComponents from './components/'

const initializeCore = (app) => {
  installComponentLayouts(app)
  installComponents(app)
}

export default initializeCore
